import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {Modal} from 'react-bootstrap';
import {useBulkActionsContext} from '../contexts/BulkActionsContext';
import {transfersSelectStyles} from '../../_common/styles/reactSelectStyles';
import DataItemSelectAsync from '../../_common/components/DataItemSelectAsync';
import styles from './styles.module.scss';

const PopupSetOwnership = ({disabled}) => {
  const [agentID, setAgentID] = useState(0);
  const [show, setShow] = useState(false);
  const handleShowModal = () => setShow(true);
  const handleCloseModal = () => setShow(false);
  const {handleSetOwnership, findAgents} = useBulkActionsContext();

  return (
    <>
      <button className={styles.secondary}
              disabled={disabled}
              onClick={() => handleShowModal()}
      >
        <FormattedMessage id={`transfersByAgent-bulk-actions-change-ownership`} defaultMessage={'Change ownership'}/>
      </button>
      <Modal show={show} onHide={handleCloseModal} className={styles.modalContainer}>
        <Modal.Body>
          <h3 className={styles.headerText}>
            <FormattedMessage id={'transfersByAgent-popup-set-ownership-header'} defaultMessage={'Set ownership'}/>
          </h3>
          <DataItemSelectAsync
            fieldId={'agentID'}
            containerStyle={'mb-5 mx-auto w-400px'}
            customStyles={transfersSelectStyles}
            loadOptions={findAgents}
            getOptionLabel={e => [e.agentID, e.fullName, e.idNumber].filter(Boolean).join(' - ')}
            getOptionValue={e => e.agentID}
            onChange={(value) => Boolean(value?.agentID) ? setAgentID(value.agentID) : setAgentID(0)}
          />
          <div className={styles.actions}>
            <button
              className={styles.btnCancel}
              onClick={() => handleCloseModal()}
            >
              <FormattedMessage id={'label-button-cancel'} defaultMessage={'Cancel'}/>
            </button>
            <button
              className={styles.btnSave}
              onClick={async () => {
                if (agentID) {
                  await handleSetOwnership(parseInt(agentID));
                  handleCloseModal();
                }
              }}
              disabled={!agentID}
            >
              <FormattedMessage id={'label-button-confirm'} defaultMessage={'Confirm'}/>
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupSetOwnership;